import { ReactNode } from 'react'
import cx from 'classnames'
import { ChipProps } from 'components/Chip/Types'
import { Chip } from 'components/Chip/Chip'
import { ListProps, useListState } from '@react-stately/list'
import Styles from './ChipSelect.module.scss'
import { ItemProps } from '@react-types/shared'
import { Item } from '@react-stately/collections'
import { Placement } from '@floating-ui/core'

export interface ChipSelectProps extends Pick<ChipProps, 'variant' | 'deletable' | 'size'>, ListProps<ChipProps> {
  limit?: number
  inline?: boolean
}

interface ChipItemProps<T> extends ItemProps<T> {
  icon?: ReactNode
  color?: string
  tooltipLabel?: string
  tooltipPlacement?: Placement
}

export const ChipItem: <T>(props: ChipItemProps<T>) => JSX.Element = Item

export const ChipSelect = ({
  variant,
  deletable,
  size,
  selectionMode = 'single',
  limit,
  inline = false,
  ...listProps
}: ChipSelectProps) => {
  const state = useListState({ ...listProps, selectionMode })
  return (
    <div className={cx(Styles.root, { [Styles.inline]: inline })}>
      {[...state.collection].map((item) => (
        <Chip
          key={item.key}
          aria-label={item.textValue}
          icon={item.props.icon}
          variant={variant}
          size={size}
          deletable={deletable}
          isSelected={state.selectionManager.isSelected(item.key)}
          color={item.props.color}
          tooltipLabel={item.props.tooltipLabel}
          tooltipPlacement={item.props.tooltipPlacement}
          onChange={() => {
            if (
              !state.selectionManager.isSelected(item.key) &&
              limit &&
              state.selectionManager.selectedKeys.size === limit
            ) {
              const lastEntry = [...state.selectionManager.selectedKeys].pop()
              lastEntry && state.selectionManager.selectedKeys.delete(lastEntry)
            }

            state.selectionManager.toggleSelection(item.key)
          }}
        >
          {item.rendered}
        </Chip>
      ))}
    </div>
  )
}
